import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { parse, stringifyUrl } from 'query-string';
import { TokensDto } from '@oh-auth/dto/lib';
import { useRecoilValue } from 'recoil';

import { tokensState, consentSessionIdState } from '../../features/auth';
import makeId from '../../helpers/makeId';
import { configState } from '../../features/config';
import { Authorize } from './Authorize';

interface ConsentProps {
	consent_uri: string;
	approval_challenge?: string;
	approval_verifier?: string;
	approval_verifier_expired_at?: string;
}

export function Consent(props: ConsentProps) {
	const {
		consent_uri,
		approval_challenge,
		approval_verifier,
		approval_verifier_expired_at,
	} = props;
	const { search } = useLocation();
	const { client_id, scope, consented } = parse(search) as any;
	const { sub } = useRecoilValue(tokensState) as TokensDto;
	const consent_session_id = useRecoilValue(consentSessionIdState);

	const { CONSENT_STATE_BYTES } = useRecoilValue(configState);

	useEffect(() => {
		if (!consented) {
			sessionStorage.setItem(
				'consent_session_id',
				makeId(CONSENT_STATE_BYTES)
			);
			window.location.replace(
				stringifyUrl({
					url: consent_uri,
					query: {
						client_id,
						scope,
						sub,
						consent_session_id,
					},
				})
			);
			return;
		}
	}, [
		CONSENT_STATE_BYTES,
		client_id,
		scope,
		sub,
		consent_session_id,
		consent_uri,
		consented,
	]);

	return consented ? (
		<Authorize
			consented={consented}
			approval_challenge={approval_challenge}
			approval_verifier={approval_verifier}
			approval_verifier_expired_at={approval_verifier_expired_at}
		/>
	) : null;
}
